import { render, staticRenderFns } from "./GoArtConfirm.vue?vue&type=template&id=4bac13b5&scoped=true"
import script from "./GoArtConfirm.vue?vue&type=script&lang=js"
export * from "./GoArtConfirm.vue?vue&type=script&lang=js"
import style0 from "./GoArtConfirm.vue?vue&type=style&index=0&id=4bac13b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac13b5",
  null
  
)

export default component.exports